<template>
	<transition name="run">
		<div v-if="isShow" class="page-first page-home page-generate" :style="'height: '+height+'px'">
			<div class="generate-content" :style="cStyle">
				<div class="generate-ani generate-ani-sun" :class="'a'+earthNum" :style="'height: '+height+'px'"></div>
				<div class="generate-ani generate-ani-earth" :class="'a'+earthNum"></div>
				<div class="generate-ani generate-ani-man" :class="'a'+manNum" v-if="userInfo.sex == 0"></div>
				<div class="generate-ani generate-ani-woman" :class="'a'+manNum" v-if="userInfo.sex == 1"></div>
			</div>
			<div class="generate-progress">
				<div class="generate-loading-text">
					<p>{{ loadingText[loadingIndex] }}</p>
				</div>
				<div class="generate-loading-box">
					<div class="generate-loading-bar-box">
						<div class="generate-loading-bar" :style="'width: '+loadingNum+'%'">
							<span v-for="i in 30" class="bar-item"></span>
						</div>
					</div>
				</div>
				<div class="generate-loading-percent">{{ loadingNum+'%' }}</div>
			</div>
		</div>
	</transition>
</template>

<script>
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
export default {
	name: "Generate",
	components: {  },
	computed: {
		userInfo() {
			return this.fromPage == 'strong' ? this.$store.state.user.strongUserInfo : this.$store.state.detail.personInfo;
		}
	},
	data() {
		return {
			isShow: true,
			fromPage: '',
			height: 720,
			manTime: 80, manNum: 1,
			earthTime: 120, earthNum: 1,
			cStyle: '',
			loadingText: [
				'正在根据八字创建五行能量数据模型……',
				'数据模型已创建，正在计算五行喜忌及天赋能力……',
				'正在根据能量喜忌生成流年运势报告……',
				'正在计算人生运势轨迹，生成最终的报告……',
			],
			loadingIndex: 0,
			loadingFunc: undefined,
			loadingNum: 0,
			curParams: {},
		}
	},
	mounted() {
		this.$bus.on('setCurParams', this.setCurParams);
		let curParams = this.$router.history.current.params;
		this.fromPage = curParams.from;
		if(curParams.from == 'strong') {
			DOM.setDocumentTitle(doctitle.TITLE_STRONG);
		}
		setTimeout(function() {
			this.height = innerHeight;
			this.initDom();
			this.initAnimation();
			this.initLoading();
		}.bind(this), 20);
	},
	destroyed() {
		this.$bus.off('setCurParams', this.setCurParams);
	},
	methods: {
		initDom() {
			this.$el.style.height = window.screen.height+'px';
			var scaleX = parseFloat(innerWidth/750), 
				scaleY = parseFloat(window.screen.height/1334);
			var cLeft = innerWidth-750, 
				cTop = window.screen.height >= 800 ? scaleY*window.screen.height-window.screen.height-20 : (window.screen.height-1334)/2;
			// console.error('generate------', cLeft, cTop, innerWidth, window.screen.height)
			var scaleValue = scaleX > scaleY ? scaleY : scaleX;
			this.cStyle = this.cStyle+ 'transform: scale('+scaleValue+','+scaleValue+'); left: '+cLeft/2+'px; top: '+cTop+'px';
		},
		initAnimation() {
			var me = this;
			function ani1() {
				me.manNum = me.manNum == 16 ? 1 : me.manNum+1;
				setTimeout(ani1, me.manTime)
			}
			ani1();
			
			function ani2() {
				me.earthNum = me.earthNum == 16 ? 1 : me.earthNum+1;
				setTimeout(ani2, me.earthTime)
			}
			ani2();
		},
		initLoading() {
			var me = this, speed = 50; //50
            function runLoad() {
                // console.error('runLoad-----', me.timeStr)
				me.loadingIndex = (me.loadingNum >= 0 && me.loadingNum < 25) ? 0 : (me.loadingNum >= 25 && me.loadingNum < 50) ? 1 : (me.loadingNum >= 50 && me.loadingNum < 75) ? 2 : 3;
				if(me.loadingNum < 100) {
					var randNum =  Math.floor(Math.random() * 3) + 1;
					var randTime = (Math.floor(Math.random() * 10) + 1)*speed;
                    me.loadingNum += randNum;
					me.loadingNum = me.loadingNum > 100 ? 100 : me.loadingNum;
                    me.loadingFunc = setTimeout(() => {
                        runLoad();
                    }, randTime);
				}else if(me.loadingNum >= 100) {
					clearTimeout(me.loadingFunc);
					me.isShow = false;
					me.gotoPage();
				}
            }
            runLoad();
		},
		gotoPage() {
			if(this.fromPage == 'strong') {
				let detailInfo = this.$store.state.report.detailInfo;
				this.$router.replace('/strong-report/'+detailInfo.id);
			}else if(this.fromPage == 'year') {
				let curParams = this.curParams;
				console.log('gotoPage-----', curParams);
				this.$store.dispatch('year/getYearReportInfo', {
					first: true,
					cb: ()=> {
						if(curParams && curParams.from && curParams.from != '') {
							this.$router.replace('/year/'+curParams.from+'/'+curParams.id);
						}
					}
				});
			}
		},
		setCurParams(curParams) {
			console.log('setCurParams-----', curParams);
			this.curParams = curParams;
		}
	}
}
</script>

<style lang="scss" scoped>
    .run-leave-active {
        animation: generateZoom 0.5s linear;
    }
	@keyframes generateZoom {
	0%{
		transform: scale(1);
		opacity: 1;
	}
	40% {
		transform: scale(2);
		opacity: 0.5;
	}
	100% {
		transform: scale(3);
		opacity: 0;
	}
}
</style>